// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"131":"5419dadc","174":"0c0878e0","580":"8546c5d0","857":"438e2df3","961":"b5d79706"}[chunkId] + ".css";
};